import { type AssignmentDTO } from '@api/models';
import { Injectable, Pipe, type PipeTransform } from '@angular/core';
import { Globals } from '@system/globals';

@Pipe({
  name: 'assignmentsfilter',
  standalone: true,
})
@Injectable({
  providedIn: 'root',
})
export class AssignmentFilterPipe implements PipeTransform {
  transform(value?: AssignmentDTO[], activeOnly = false): AssignmentDTO[] {
    if (!value) {
      return [];
    }

    return activeOnly ? value.filter(x => x.statusId === Globals.STATUS_ASSIGNMENT_IN_PROGRESS) : value;
  }
}
